import { ArticleData } from '../entities/article';
import { isChanneled, isTagged } from './utils';

export const getPaywallType = (article: ArticleData) => {
  const paywallTags = {
    'c-suite-buys-of-the-week': 943954,
    'easy-income-portfolio': 944696,
    'insider-report': 938584,
    interviews: 714112,
    mavens: 154244,
    'options-trade-of-the-day': 946635,
    'perfect-stock-portfolio': 944719,
    'stock-of-the-day': 931449,
    'stock-whisper-index': 866728,
    'under-the-radar': 943823,
  };

  if (isTagged(article, Object.values(paywallTags))) return 'hard';
  return 'soft-hard';
};

export const getPaywallContentType = (article: ArticleData) => {
  if (isTagged(article, [931449])) return 'stock-of-the-day';
  if (isTagged(article, [866728])) return 'whisper-index';
  if (isChanneled(article, [68])) return 'analyst-color';
  if (isTagged(article, [944696])) return 'easy-income-portfolio';
  if (isTagged(article, [944719])) return 'perfect-stock-portfolio';
  // if (isTagged([938584])) return 'insider-report';
  return 'default-article';
};
